import { gql } from '@apollo/client';

export const SESSION_COOKIE = 'rbp_sessionID';
export const GA_COOKIE = '_ga';

export const ZIPCODE_TO_STATECODE = gql`
  query GetStateFromZipCode($zipCode: String!) {
    stateFromZipCode(zipCode: $zipCode)
  }
`;

export const GET_CUSTOMER_NUMBER = gql`
  query GetCustomerNumber($email: String!) {
    customerNumber(email: $email)
  }
`;

export const USER_HAS_PRODUCT = gql`
  query UserHasProduct($email: String!, $product: String!) {
    userHasProduct(email: $email, product: $product)
  }
`;

export const GET_RATES = gql`
  mutation rate($ratingInput: RatingInput!) {
    rate(ratingInput: $ratingInput) {
      planRates {
        productType
        planCode
        productCode
        available
        monthlyPrice
        annualPrice
        pricingTier
        stateCode
      }
    }
  }
`;

export const AUTHORIZE = gql`
  mutation authorizeMutation($authorizeInput: AuthorizeInput!) {
    authorize(authorizeInput: $authorizeInput) {
      paymentToken
      requestID
      transactionId
    }
  }
`;

export const FETCH_PAYMENT_INFO = gql`
  query fetchPaymentInformation($paymentTokenId: String) {
    paymentInformation(paymentTokenId: $paymentTokenId) {
      card {
        suffix
      }
    }
  }
`;

export const ENROLL = gql`
  mutation enrollMutation($enrollmentInput: EnrollmentInput!) {
    enroll(enrollmentInput: $enrollmentInput)
  }
`;

export const ENROLL_AGGREGATE = gql`
  mutation enrollAggregateMutation($enrollmentInput: EnrollmentInput!) {
    enrollAggregate(enrollmentInput: $enrollmentInput) {
      customerNumber
      planDetails {
        policyNumber
        planCode
        productCode
      }
    }
  }
`;

export const CREATE_LEAD = gql`
  mutation createLead(
    $firstName: String
    $email: String
    $source: SourceInput
    $validate: Boolean
    $gclid: String
  ) {
    createLead(
      firstName: $firstName
      email: $email
      source: $source
      validate: $validate
      gclid: $gclid
    )
  }
`;

export const SAVE_QUOTE = gql`
  mutation saveQuote(
    $email: String!
    $firstName: String
    $ratingInput: RatingInput!
    $recommendedPlan: String
    $leadSource: String
    $validate: Boolean
    $gclid: String
    $utmInfo: UtmInfo
    $partnerInfo: PartnerInfo
    $pageURL: String
  ) {
    saveQuote(
      email: $email
      firstName: $firstName
      ratingInput: $ratingInput
      recommendedPlan: $recommendedPlan
      leadSource: $leadSource
      validate: $validate
      gclid: $gclid
      utmInfo: $utmInfo
      partnerInfo: $partnerInfo
      pageURL: $pageURL
    ) {
      quoteId
      success
      error
    }
  }
`;

export const REQUEST_ADDITIONAL_STATES = gql`
  mutation requestAdditionalStates(
    $requestStatesForm: RequestAdditionalStatesFormInput
  ) {
    requestAdditionalStates(requestStatesForm: $requestStatesForm)
  }
`;

export const GET_AGENT_INFORMATION = gql`
  query agentInformation($agencyId: String!, $agentEntityId: String!) {
    getAgentInformation(agencyId: $agencyId, agentEntityId: $agentEntityId) {
      agentID
      firstName
      lastName
      entityStatus
    }
  }
`;

export const SEND_REQUEST_APPOINTMENT_FORM = gql`
  mutation sendRequestAppointmentForm(
    $requestAppointmentForm: RequestAppointmentFormInput
  ) {
    sendRequestAppointmentForm(requestAppointmentForm: $requestAppointmentForm)
  }
`;

export const SAVE_QUOTE_TO_EIS = gql`
  mutation SaveQuoteToEIS($saveQuoteInput: GlicBrokerLeadRequest) {
    upsertBrokerLead(saveQuoteInput: $saveQuoteInput) {
      success
      leadId
      error
    }
  }
`;

export enum AsideProductDescriptionsEnum {
  'Premier Dental' = 'Preventive care, basic care, and major care. Includes orthodontia and teeth whitening, and our highest maximum.',
  'Diamond Dental' = 'Preventive care, basic care, and major care. Includes orthodontia and teeth whitening.',
  'Achiever Dental' = 'Preventative care, basic care, major care, and orthodontia included. Teeth whitening not included.',
  'Core Dental' = 'Preventive care, basic care, and major care. Orthodontia and teeth whitening not included.',
  'Starter Dental' = 'Preventive care and basic care. Major care, orthodontia, and teeth whitening not included.',
  'Achiever Vision' = 'All our benefits in one plan for those that need the most coverage.',
  'Core Vision' = 'Many benefits in one plan for comprehensive coverage.',
  'Standard Vision' = 'Many benefits in one plan for comprehensive coverage.',
  'Achiever 2.0 Accident' = 'Lump sums for covered accidents that can be used toward unanticipated expenses.',
  'Core 2.0 Accident' = 'Smaller lump sums for covered accidents that can be used toward unanticipated expenses.',
}

export const BRITEVERIFY = gql`
  mutation briteVerifyEmail($email: String!) {
    briteVerify(email: $email) {
      validity
    }
  }
`;
